import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { initTheme } from '@/stores/ui.store'

// Aplica clase .dark / light ANTES del primer paint (tokens CSS correctos)
initTheme()

const el = document.getElementById('root')
if (!el) {
  throw new Error('root element missing')
}

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// La instalación del Workspace ya NO se ofrece sola en el navegador: es
// deliberada, vía el instalador .exe que reparte el admin desde
// Configuración → Call Center (ver electron/). Un manifest + service worker
// registrados es justo lo que hace que Chrome/Edge ofrezcan "Instalar app"
// a cualquiera que visite el sitio — se desactiva a propósito.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    for (const r of regs) {
      if (r.active?.scriptURL.includes('sw-cc.js')) r.unregister()
    }
  }).catch(() => {})
}
